module.exports = __webpack_public_path__ + "img/08.2c379a02.jpg";